import React from "react";
import { BreadCrumb } from "primereact/breadcrumb";
import { Link } from "react-router-dom";

export const Crumbs = (props) => {
  const url = window.location.pathname;
  let newpath = url.split("/");
  const items = [
    {
      label: "Home",
      template: () => (
        <Link to="/Home" className="no-underline text-black-alpha-90">
          Home
        </Link>
      ),
    },
    {
      label: `{window.location.pathname}`,
      template: () => (
        <Link
          to={`${window.location.pathname}`}
          className="no-underline text-red-700 capitalize "
        >
          {newpath}
        </Link>
      ),
    },
  ];
  const home = { icon: "pi pi-home", url: "https://primereact.org" };
  return (
    <div className="container  pl-0  mt-4 pt-4 " style={{display:'flex' ,alignItems:'center', justifyContent:'flex-start' ,height:'fit-content',paddingLeft:'0px !importent'}}>
      <div className="grid ml-0   " style={{display:'flex' ,alignItems:'center', justifyContent:'flex-start',height:'fit-content' ,marginBottom:'-40px' }}>
        <BreadCrumb
          model={items}
          className="border-none  text-base  pl-0 font-medium"
        />
      </div>
    </div>
  );
};


// order-none  text-base  pl-0   ====== mb-2